export const testimonials = [
  {
    quote:
      'Aveam 47 de angajați și totuși mă sunam cineva pentru fiecare decizie. După 6 luni cu Valer, am plecat 3 săptămâni în vacanță și cifra de afaceri a crescut cu 12%. Nu exagerez — pur și simplu sistemul funcționează.',
    name: 'Radu N.',
    role: 'Antreprenor — Distribuție & Logistică',
    initials: 'RN',
  },
  {
    quote:
      'Credeam că problema e că nu găsesc oameni buni. Valer mi-a arătat că problema era că nu aveam procese clare pe care oamenii să le urmeze. Am restructurat totul în 4 luni și acum echipa livrează constant fără mine în spate.',
    name: 'Ioana C.',
    role: 'Antreprenor — Servicii IT & Software',
    initials: 'IC',
  },
  {
    quote:
      'Am vândut compania la 2 ani după ce am terminat implementarea cu Valer. Cumpărătorul a spus că l-a convins faptul că totul era documentat și funcționa independent de mine. Fără PROVI System, nu cred că aș fi reușit.',
    name: 'Vlad T.',
    role: 'Antreprenor — Producție & Manufacturing',
    initials: 'VT',
  },
]
